import React from "react";
import KnowledgeBackedProfileChapter from "./KnowledgeBackedProfileChapter";

// Communication-specific classification and copy stay in its domain builder.
// The source-routed Profile lifecycle is shared by every Knowledge chapter.
const ProfileCommunicationChapter = (props) => (
  <KnowledgeBackedProfileChapter {...props} presentationMode="profileItems" showGroupHeadings />
);

export default ProfileCommunicationChapter;
